export enum EMPTY_VALUE {
  DASH = '-',
  NA = 'n/a'
}
